/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

export default [
  //
  // sort by path
  //
  {
    name: 'Dashboard',
    path: '/dashboard/:workspaceId',
    view: 'Dashboard',
  },
  {
    name: 'Model',
    path: '/model/:masterId',
    view: 'Master',
  },
  {
    name: 'Checklist',
    path: '/checklist/:instanceId',
    view: 'Instance',
  },
  {
    name: 'Login',
    path: '/login',
    view: 'Login',
  },
  {
    name: 'Account',
    path: '/account',
    view: 'Account',
  },
  {
    name: 'Settings',
    path: '/settings',
    view: 'Settings',
  },
  {
    name: 'Test',
    path: '/test',
    view: 'Test',
  },
  {
    name: 'Registration',
    path: '/registration',
    view: 'Registration',
  },
  {
    name: 'RegistrationAcknowledge',
    path: '/registrationacknowledge',
    view: 'RegistrationAcknowledge',
  },
]
